module.exports = __webpack_public_path__ + "img/zsjm-6.c5c84279.webp";